<template>
  <div class="trainingstatistics">
    <div class="header">
      <div class="right">
        <el-button class="minbtn" size="mini" @click="querycensus(1)">近一个月</el-button>
        <el-button class="minbtn" size="mini" @click="querycensus(3)">近三个月</el-button>
        <el-button class="minbtn" size="mini" @click="querycensus(6)">近半年</el-button>
        <el-button class="minbtn" size="mini" @click="querycensus(12)">近一年</el-button>
        <el-date-picker value-format="yyyy-MM-dd"  format="yyyy-MM-dd" style="width: 220px;height: 32px;margin-left:20px"  v-model="censusDate" type="daterange"  range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"></el-date-picker>
        <el-button type="primary" style="margin-left:20px;" @click="czfun()">重置</el-button>
      </div>
    </div>

    <!-- 统计 -->
    <div class="statistics">
      <div class="item" style="width: 48%;">
        <div ref="Trainingcontentstatistics" style="width:100%;height:350px;margin: auto;" v-loading="statisticsloading"></div>
      </div>
      <div class="item" style="width: 22%;">
        <div ref="education" v-loading="statisticsloading" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div>
      </div>
      <div class="item" style="width: 22%;">
        <div ref="education2" v-loading="statisticsloading" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div>
      </div>
    </div>
    <div class="content">
      <div>
        <el-input v-model="param.searchValue" placeholder="请输入培训主题查询" clearable style="width: 200px;margin-right: 30px"></el-input>
        <el-button type="primary" @click="getTrainingStatistics">{{ $t('Education.languages01')}}</el-button>
        <el-button type="primary" @click="ClickExport">{{ $t('Education.languages20')}}</el-button>
      </div>
      <el-table v-loading="loadings" :data="trainingData" :cell-style="{'text-align':'center'}" style="width: 100%;margin-top:20px">
        <el-table-column prop="trainName" label="培训主题"></el-table-column>
        <el-table-column prop="courseSize" label="课程数" width="80"></el-table-column>
        <el-table-column prop="trainTime" label="培训时间"></el-table-column>
        <el-table-column prop="totalHours" label="总课时" width="80"></el-table-column>
        <el-table-column prop="totalPeople" label="培训人数" width="120"></el-table-column>
        <el-table-column prop="enrollNum" label="报名人数" width="120"></el-table-column>
        
        <el-table-column label="报名占比/人数">
          <template v-slot="scope">
            <div style="cursor: pointer;">
              <el-col :span="16">
                <el-progress :text-inside="true" :stroke-width="20" :color="stydycolor" :percentage="scope.row.enrollNumProportion"></el-progress>
              </el-col>
              <el-col :span="6" :offset="1">{{scope.row.enrollNum}}</el-col>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="date" label="考试占比/人次">
          <template v-slot="scope">
            <div style="cursor: pointer;">
            <el-col :span="16">
              <el-progress :text-inside="true" :stroke-width="20" :color="stydycolor" :percentage="scope.row.examNumProportion"></el-progress>
            </el-col>
            <el-col :span="6" :offset="1">{{scope.row.examNum}}</el-col>
          </div>
          </template>
        </el-table-column>

        <el-table-column prop="date" label="通过占比/人数">
          <template v-slot="scope">
            <el-col :span="16">
              <el-progress :text-inside="true" :stroke-width="20" :color="stydycolor" :percentage="scope.row.passNumProportion"></el-progress>
            </el-col>
            <el-col :span="6" :offset="1">{{scope.row.passNum}}</el-col>
          </template>
        </el-table-column>


        <el-table-column label="操作">
          <template v-slot="scope">
            <div @click="$router.push('learningstatistics?trainId='+scope.row.trainId)" style="cursor: pointer;color: #409EFF;">
              查看
            </div>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination style="margin-top: 20px;" hide-on-single-page @current-change="handleCurrentChange" :current-page.sync="param.pageNum" :page-size="param.pageSize" layout="total, prev, pager, next" :total="param.Total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default ({
  name:'trainingstatistics',
  data(){
    return{
      loadings:true,
      trainingData:[],
      param:{
        pageNum:1,
        pageSize:10,
        searchValue:'',
        Total:0,
        startTime:'',
        endTime:''
      },
      stydycolor:[
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#ff882c', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#3ea660', percentage: 100}
      ],
      TrainingStatisticsChartData:'',
      censusDate:this.Global.querycensus(6),
      censusparams:{
        startTime:'',
        endTime:''
      },
      statisticsloading:false
    }
  },
  watch:{
    censusDate(newval,oldeval){
      if(newval){
        this.censusparams.startTime = newval[0];
        this.censusparams.endTime = newval[1];
        this.param.startTime = newval[0]; 
        this.param.endTime = newval[1];
      }else{
        this.censusparams.startTime = "";
        this.censusparams.endTime = "";
        this.param.startTime = "";
        this.param.endTime = "";
      }
      this.getTrainingStatistics();
    }
  },
  created() {
    this.querycensus(12)
    this.getTrainingStatistics();
    this.getTrainingStatisticsChart();
  },
  methods:{
    czfun(){
      this.querycensus(12)
    },
    // 获取统计列表
    getTrainingStatisticsChart(){
      this.statisticsloading=true;
      this.$Http_Post('/edu/train/getTrainingStatisticsChart',this.censusparams).then(res=>{
        this.statisticsloading=false;
        if(res.Code==0 || res.Code==200){
          this.TrainingStatisticsChartData=res.Data;
          this.$nextTick(()=>{
            this.contentstatistics(res.Data.statisticalChart);
            this.education();
            this.education2()
          })
        }else{
          this.$message({type: 'error', message:"获取图形数据失败!"});
        }
      })
    },
    //培训内容统计
    contentstatistics(data){
      var myChart = this.$echarts.init(this.$refs.Trainingcontentstatistics);
      var option={
        title: {
          text: '培训数据',
          left: '20px',
          top: '10px',
        },
        tooltip: {
          trigger: 'item'
        },
        color:['#93C22D', '#557CD9', '#E3B540','#44B9AC'],
        legend: {
          right:'0',
          data:['报名人数','学习人数', '考试人数', '通过人数']
        },
        xAxis: { type: 'category',data:data.month},
        yAxis: { splitLine: { show: true, lineStyle: { type: 'dashed' } } },
        series: [
          {
            name:'报名人数',
            data: data.trainNum,
            type: 'bar',
            barMaxWidth: '15',
          }, 
          { 
            name:'学习人数',
            data: data.studyNum,
            type: 'bar',
            barMaxWidth: '15',
          },{
            name:'考试人数',
            data: data.examNum,
            type: 'bar',
            barMaxWidth: '15',
          },{ 
            name:'通过人数',
            data:data.passNum,
            type: 'bar',
            barMaxWidth: '15',
          },
        ]
      }
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    // 学历占比
    education(){
      var myChart = this.$echarts.init(this.$refs.education);
      var option = {
        title: {
          text: '教育培训(学历)',
          left: '20px',
          top: '10px',
        },
        tooltip: {
          trigger: 'item'
        },
        color:['#93C22D','#557CD9','#E3B540'],
        legend: {
          top: '90%',
          left: 'center',
          selectedMode: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            data: []
          }
        ]
      };
      for(let item of this.TrainingStatisticsChartData.degreeProportion){
        let data={value:item.count,name:item.degree};
        option.series[0].data.push(data);
      }
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    education2(){
      var myChart = this.$echarts.init(this.$refs.education2);
      var option = {
        title: {
          text: '教育培训(性别)',
          left: '20px',
          top: '10px',
        },
        tooltip: {
          trigger: 'item'
        },
        color:['#93C22D', '#557CD9'],
        legend: {
          top: '90%',
          left: 'center',
          selectedMode: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            data: []
          }
        ]
      };
      for(let item of this.TrainingStatisticsChartData.sexProportion){
        let data={value:item.count,name:item.sex};
        option.series[0].data.push(data);
      }
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    //根据选项查询 
    querycensus(data){
      this.censusDate = this.Global.querycensus(data);
      this.censusparams.startTime = this.censusDate[0];
      this.censusparams.endTime = this.censusDate[1];
      this.getTrainingStatisticsChart();
    },
    getTrainingStatistics(){
      this.loadings = true;
      this.$Http_Post('edu/train/getTrainingStatistics',this.param).then(res=>{
        if(res.Code == 0){
          this.trainingData = res.Data;
          this.param.Total = res.Counts;
        }else{
          this.$message({type: 'error', message:res.Message});
        }
        this.loadings = false;
      })
    },
    handleCurrentChange(val){
      this.param.pageNum = val;
      this.getTrainingStatistics();
    },
    ClickExport(){
      location.href=process.env.VUE_APP_URL+'edu/train/exportTrainingStatistics?searchValue='+this.param.searchValue
    }
  }
})
</script>
<style>
.trainingstatistics .header{display: flex;align-items:center;padding:20px 30px;background: #fff;justify-content: space-between;}
.trainingstatistics .content{background:#fff;padding:30px;margin-top:20px;}
.trainingstatistics .el-progress-bar__innerText{color: #000;}
.trainingstatistics .statistics{margin: 20px 0;display:flex;}
.trainingstatistics .minbtn{height: 32px!important;padding: 0px;width: 72px;}
.trainingstatistics .statistics::after{content: '';clear: both;display: block;height:0;}
.trainingstatistics .statistics .item{background: #fff;padding: 20px;margin: 0 20px 0 0;float: left;}
.trainingstatistics .statistics .item:last-child{margin: 0;}
.trainingstatistics .statistics .item .condition{margin-bottom: 20px;}
.trainingstatistics .header .right{display: inline-block;}
.trainingstatistics .header .el-date-editor .el-range__icon,
.trainingstatistics .header .el-date-editor .el-range-separator,
.trainingstatistics .header .el-date-editor .el-range__close-icon{line-height: 24px;}
.trainingstatistics .statistics .el-range-editor .el-range-input{font-size: 12px;}
</style>